<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="4">
					<select-combo
						:label="getMessage_('MWCC000105')"
						paramKey="cdDesc"
						:options="factoryList_"
						@commChange="changeFactory"
					></select-combo>
				</el-col>
				<el-col :span="4">
					<select-combo
						:label="getMessage_('MWCC000106')"
						paramKey="lineCd"
						:options="lineFilteredList_"
						@commChange="changeLine"
						:initData="secondCombo"
					></select-combo>
				</el-col>
				<el-col :span="4">
					<multi-select-combo
						:label="getMessage_('MWCC000106')"
						paramKey="lineCdList"
						:options="lineFilteredList_"
						@commChange="changeMulti"
						:initData="secondCombo"
					></multi-select-combo>
				</el-col>
			</el-row>
			<template slot="button">
				<!-- <sf-button line icon="search" :onClick="() => {}" v-if="isButton_(scrId, 'CR')">
					{{ scrId }}
				</sf-button> -->
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import SelectCombo from '@qms/Components/SelectCombo.vue';
import MultiSelectCombo from '@qms/Components/MultiSelectCombo.vue';
export default {
	props: { scrId: { type: String, default: '' } },
	data() {
		return {
			secondCombo: false
		};
	},
	components: { SelectCombo, MultiSelectCombo },
	async created() {
		try {
			await this.getFactoris_();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message || error
			});
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		/* 필터된 리스트 사용시 필요함 */
		async changeFactory(param) {
			await this.setCommCode_(param);
			await this.getLinesFiltered_();
			this.secondCombo = !this.secondCombo;
		},
		async changeLine(param) {
			await this.setCommCode_(param);
		},
		async changeMulti(param) {
			await this.setCommCode_(param);
		}
	},
	computed: { ...rootComputed, ...serviceComputed }
};
</script>

<style></style>
